module.exports = __webpack_public_path__ + "img/product_stat5.d77bbd9d.png";